<div class="initial-tab-focus" #initialTabFocus tabindex="-1"></div>
<a
  [matomoTracker]="['enter', 'click']"
  matomoCategory="Accessibility"
  matomoAction="Skip to content"
  class="skip-to-content-link"
  href="./#main"
  (click)="skipToContentLink($event)"
  >{{ 'CORE.COMPONENTS.SKIP-TO-CONTENT' | translate }}</a
>
<div class="page-container">
  <app-header></app-header>
  <app-main-navigation-mobile (expandedChange)="onSidebarMenuExpanded($event)"></app-main-navigation-mobile>
  <div class="page-body" [class.hidden]="sidebarMenuExpanded()">
    @defer {
      <app-system-messages></app-system-messages>
    }
    @if (!hideBreadcrumbs()) {
      <app-breadcrumb></app-breadcrumb>
    }
    <main id="main">
      <router-outlet></router-outlet>
    </main>
    <app-to-the-top-link></app-to-the-top-link>
    <app-footer></app-footer>
  </div>
</div>

@defer {
  <app-chat-integration></app-chat-integration>
}
